import React from 'react';
import { ReactComponent as LogoLetterK } from '@/presentation/assets/img/logo/logo-letter-k.svg';
const BouncyLoader = () => {
    return (React.createElement("div", { className: 'bouncy-component' },
        React.createElement("div", { className: 'bouncy-container' },
            React.createElement(LogoLetterK, { className: 'bouncy-logo' }),
            React.createElement("div", { className: 'bouncy-shadow' }))));
};
export default BouncyLoader;
